import React, { useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Button, Card, DatePicker } from "antd";
import { getColumnsDataComplex } from "./variables/columnsData";
import CommonTable from "components/common/CommonTable";
import Request from "helpers/request";
import { urls } from "helpers/urls";

const processData = (data) => {
  if (!Array.isArray(data)) {
    return [];
  }
  // Flatten the data structure
  const flatData = data.flatMap((session, sessionIndex) =>
    session.messages.map((message, messageIndex) => ({
      key: `${sessionIndex}-${messageIndex}`,
      session_id: session.session_id,
      question: message.user_query,
      answer: String(message.assistant_response || "").replace(/<[^>]*>/g, ""),
      rating: message.rating,
      site_id: session.site_id,
      site_name: session.site_name,
      ip_address: session.ip_address,
      created_at: message.created_at,
    }))
  );

  // Sort by created_at in descending order (newest first)
  return flatData.sort(
    (a, b) => new Date(b.created_at) - new Date(a.created_at)
  );
};

const CustomDatePickerInput = React.forwardRef(
  ({ value, onClick, placeholder }, ref) => (
    <button
      className="w-full rounded-md border bg-white py-1.5 px-3 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
      onClick={onClick}
      ref={ref}
    >
      {value || placeholder}
    </button>
  )
);

const Tables = () => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [logdata, setLogdata] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [siteNames, setSiteNames] = useState([]);
  const [loading, setLoading] = useState(false);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const getlogs = () => {
    setLoading(true);
    try {
      Request.get(urls.getlogs)
        .then((response) => {
          const processed = processData(response?.data?.data);
          setLogdata(processed);
          setFilteredData(processed);
          const uniqueSiteNames = [
            ...new Set(processed.map((item) => item.site_name)),
          ];
          setSiteNames(uniqueSiteNames);
          setLoading(false);
        })
        .catch((error) => {
          console.log("error", error);
          setLogdata([]);
          setFilteredData([]);
          setSiteNames([]);
          setLoading(false);
        });
    } catch (error) {
      console.log("error", error);
      setLogdata([]);
      setFilteredData([]);
      setSiteNames([]);
      setLoading(false);
    }
  };

  const handleFilter = () => {
    if (startDate && endDate) {
      const filtered = logdata.filter((item) => {
        const itemDate = new Date(item.created_at);
        const endOfDay = new Date(endDate);
        endOfDay.setHours(23, 59, 59, 999);
        return itemDate >= startDate && itemDate <= endOfDay;
      });
      // Keep the filtered data sorted by created_at in descending order
      setFilteredData(filtered);
    } else {
      setFilteredData(logdata);
    }
  };

  useEffect(() => {
    getlogs();
  }, []);

  return (
    <Card>
      <div>
        <div className="chatbot-card-section flex items-center justify-between gap-4">
          <div
            className="font-figtree chatbot-text text-[30px] font-bold"
            style={{ fontFamily: "figtree" }}
          >
            <h1>Logs</h1>
          </div>
          <div className="flex items-center gap-4">
            <DatePicker
              placeholder="Start Date"
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              selectsStart
              startDate={startDate}
              endDate={endDate}
              customInput={<CustomDatePickerInput placeholder="Start Date" />}
              calendarClassName="calendar_custom"
            />
            <DatePicker
              placeholder="End Date"
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              selectsEnd
              startDate={startDate}
              endDate={endDate}
              minDate={startDate}
              customInput={<CustomDatePickerInput placeholder="End Date" />}
              calendarClassName="calendar_custom"
            />
            <Button
              className="rounded-md bg-[#2369d2] py-2 px-4 text-sm font-medium text-white"
              style={{ fontFamily: "figtree" }}
              onClick={handleFilter}
            >
              Fetch Data
            </Button>
          </div>
        </div>
        <div className="logs-table-wrap mt-5 grid h-full grid-cols-1 gap-5 md:grid-cols-1">
          <CommonTable
            columns={getColumnsDataComplex(siteNames, pagination)}
            dataSource={filteredData}
            pagination={{
              ...pagination,
              onChange: (page, pageSize) => {
                setPagination({ current: page, pageSize });
              },
            }}
            loading={loading}
            style={{ fontFamily: "figtree" }}
          />
        </div>
      </div>
    </Card>
  );
};

export default Tables;
